/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Custom_UrlInputs */

const en_common_custom_url = /** @type {(inputs: Common_Custom_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom URL`)
};

const es_common_custom_url = /** @type {(inputs: Common_Custom_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL personalizada`)
};

/**
* | output |
* | --- |
* | "Custom URL" |
*
* @param {Common_Custom_UrlInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_custom_url = /** @type {((inputs?: Common_Custom_UrlInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Custom_UrlInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_custom_url(inputs)
	return en_common_custom_url(inputs)
});